import React from 'react';

import PropTypes from 'prop-types';
import dayjs from 'dayjs';

import { Badge, Button, Text } from 'modules/common';
import { jsUcFirst, removeEmpty } from 'modules/common/utils';

const renderText = (row) => {
  const label = row?.[0];
  const values = row?.[1];

  let text = values;

  if (values?.from || values?.to) {
    const newFrom = dayjs(values?.from).format('MMM DD, YYYY');
    const newTo = dayjs(values?.to).format('MMM DD, YYYY');

    if (values?.from === values?.to) return newFrom;

    text = `${newFrom} - ${newTo}`;
  }

  if (
    typeof values === 'object' &&
    values !== null &&
    (values?.label || values?.value)
  ) {
    text = values?.label || values?.value;
  }

  return `${jsUcFirst(label?.replaceAll('_', ' '))} is ${text}`;
};

function FilterBar({ value: $value, onChange }) {
  const value = Object.entries($value)
    ?.filter((item) => !['per_page', 'selected', 'page']?.includes(item?.[0]))
    ?.filter((item) => item?.[1]);

  const handleOnRemove = (propName) => {
    onChange(
      removeEmpty({
        ...value,
        [propName]: '',
      })
    );
  };

  const handleOnClear = () => {
    onChange({});
  };

  return (
    <div className="py-ds-12 px-ds-16 bg-primitive-white border border-default rounded">
      <div className="flex items-center gap-ds-16">
        <div className="flex-1">
          {value?.length <= 0 ? (
            <Text type="caption" color="muted">
              No filters added
            </Text>
          ) : (
            <div className="flex items-center flex-wrap gap-ds-8">
              {value?.map((item, key) => (
                <Badge
                  // eslint-disable-next-line react/no-array-index-key
                  key={key}
                  label={renderText(item)}
                  onClose={() => handleOnRemove(item?.[0])}
                />
              ))}
            </div>
          )}
        </div>

        <Button label="Clear Filters" size="sm" onClick={handleOnClear} />
      </div>
    </div>
  );
}

FilterBar.defaultProps = {
  value: {},
  onChange: () => {},
};

FilterBar.propTypes = {
  value: PropTypes.instanceOf(Object),
  onChange: PropTypes.instanceOf(Function),
};

export default FilterBar;
